<template>
  <div v-if="samples.length" class="sample-section">
    <div class="sample-heading"><h3>匹配结果样例</h3><span>仅展示 3 条，完整数据支付后下载</span></div>
    <div class="sample-list">
      <div v-for="sample in samples" :key="sample.isbn" class="sample-card">
        <img v-if="firstPicture(sample.pictures)" :src="firstPicture(sample.pictures)" alt="图书封面">
        <div class="book-placeholder" v-else><i class="el-icon-reading" /></div>
        <div class="sample-content">
          <strong>{{ sample.bookName || '未命名图书' }}</strong>
          <p>{{ sample.author || '作者未知' }} · {{ sample.press || '出版社未知' }}</p>
          <p>ISBN：{{ sample.isbn }}</p>
          <el-tag v-if="sample.clcName" size="mini">{{ sample.clcName }}</el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SampleList',
  props: { samples: { type: Array, default: () => [] } },
  methods: {
    firstPicture (pictures) {
      if (Array.isArray(pictures) && pictures.length) {
        return String(pictures[0]).trim()
      }
      if (typeof pictures === 'string' && pictures) {
        return pictures.split(',')[0].trim()
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
.sample-section { margin-top: 28px; }
.sample-heading { display: flex; justify-content: space-between; align-items: center; }
.sample-heading h3 { margin: 0; }
.sample-heading span { font-size: 13px; color: #909399; }
.sample-list { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 14px; }
.sample-card { display: flex; min-width: 0; padding: 13px; border: 1px solid #e8edf3; border-radius: 11px; }
.sample-card img, .book-placeholder { flex: none; width: 62px; height: 82px; border-radius: 6px; object-fit: cover; background: #f0f4f8; }
.book-placeholder { display: flex; align-items: center; justify-content: center; font-size: 25px; color: #9ca3af; }
.sample-content { min-width: 0; padding-left: 12px; }
.sample-content strong { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sample-content p { margin: 7px 0; color: #6b7280; font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
@media screen and (max-width: 768px) {
  .sample-heading { display: block; }
  .sample-heading span { display: block; margin-top: 6px; }
  .sample-list { grid-template-columns: 1fr; }
}
</style>
